<template>
  <div>
    <h1 class="text-white mb-8 font-bold text-3xl">Inversiones</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link  class="px-8 py-4 btn-indigoOrange" :href="route('inversions.create')">
        <span>Agregar</span>
        <span class="hidden md:inline">Inversión</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold" style="background-color: black; color: white;">
               <th class="px-6 pt-6 pb-4">Inversion ID</th>
               <th class="px-6 pt-6 pb-4">Cliente ID</th>
               <th class="px-6 pt-6 pb-4">Inicio</th>
               <th class="px-6 pt-6 pb-4">Tipo</th>
          <th class="px-6 pt-6 pb-4">Monto</th>
          <th class="px-6 pt-6 pb-4">Porcentaje</th>
          <th class="px-6 pt-6 pb-4">Estado</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Final</th>
        </tr>
        <tr v-for="inversion in inversions.data" :key="inversion.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('inversions.edit', inversion.id)" tabindex="-1">
              {{ inversion.id_inversion }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('inversions.edit', inversion.id)" tabindex="-1">
              {{ inversion.clientId }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('inversions.edit', inversion.id)" tabindex="-1">
              {{ inversion.inicio }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('inversions.edit', inversion.id)" tabindex="-1">
              {{ inversion.tipo }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('inversions.edit', inversion.id)">
              {{ inversion.monto }} $
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('inversions.edit', inversion.id)" tabindex="-1">
                {{ inversion.porcentaje }} %
            </inertia-link>
          </td>
         
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('inversions.edit', inversion.id)" tabindex="-1">
              {{ inversion.estado }} 
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('inversions.edit', inversion.id)" tabindex="-1">
              {{ inversion.final }} 
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('inversions.edit', inversion.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="inversions.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No Encontramos Inversiones</td>
        </tr>
      </table>
    </div>
    <pagination style="color: #ffffff;" class="mt-6" :links="inversions.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Clientes' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    inversions: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('inversions'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
